
class SlideshowGrid extends HTMLElement {

    constructor() {
        super();
        this.interval = this.dataset.interval ? parseInt(this.dataset.interval) * 1000 : 5000;

        const withFallback = (property, fallback) => {
            let val = this.style.getPropertyValue(property);
            return val.length == 0 ? fallback : parseInt(val);
        }

        this.columns = withFallback('--columns', 1);
        this.columnsTablet = withFallback('--columns-tablet', this.columns);
        this.columnsDesktop = withFallback('--columns-desktop', this.columnsTablet);

        window.addEventListener('resize', e => {
            this.updateColumns();
        });

        this.classList.add('init');
    }

    connectedCallback() {
        for (let child of this.children) {
            child.classList.add('slideshow-item');
        }
        this.index = 0;

        this.rotate();
        setInterval(() => this.rotate(), this.interval);
    }

    rotate() {
        this.start = this.index;
        this.end = this.index + Math.max(this.columns, this.columnsTablet, this.columnsDesktop);
        this.len = this.children.length;

        for (let child of this.children) {
            let handler = null;
            const classes = ['slideshow-item__visible', 'slideshow-item__visible-tablet', 'slideshow-item__visible-desktop'];

            for (let c of classes) {
                if (child.classList.contains(c)) {
                    child.classList.remove(c);
                    
                    if (handler == null) {
                        child.classList.add('transition-out');
                        handler = setTimeout(() => child.classList.remove('transition-out'), 500);
                    }
                }
            }
        }
        
        for (let i = this.start; i < this.end; i++) {
            let child = this.children[i % this.len];
            let column = i - this.start + 1;

            if (column <= this.columns) child.classList.add('slideshow-item__visible');
            else if (column <= this.columnsTablet) child.classList.add('slideshow-item__visible-tablet');
            else if (column <= this.columnsDesktop) child.classList.add('slideshow-item__visible-desktop');
        }

        this.updateColumns();
        this.index += this.numColumns;
        if (this.index >= this.len) this.index = this.index % this.len;
    }

    updateColumns() {
        let numColumns = this.columns;
        if (window.innerWidth > 768) numColumns = this.columnsTablet;
        if (window.innerWidth > 992) numColumns = this.columnsDesktop;

        for (let i = this.start; i < this.start + this.len; i++) {
            this.children[i % this.len].style.gridColumn = (i - this.start) % numColumns + 1;
        }

        this.numColumns = numColumns;
    }
}

if (!customElements.get('slideshow-grid')) customElements.define('slideshow-grid', SlideshowGrid);